import { c as _c } from "react/compiler-runtime";
import { type PropsWithChildren } from 'react';
import Skeleton from 'react-loading-skeleton';
import styles from './carousel-skeleton.module.scss';
export const CarouselSkeleton = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className={styles["carousel-skeleton__title-skeleton-wrapper"]}><Skeleton className={styles["carousel-skeleton__title-skeleton"]} height={40} width={250} /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <div className={styles["carousel-skeleton"]}>{t1}<div className={styles["carousel-skeleton__card-row"]}>{children}</div></div>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};